"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCoreAvatarMiddleware;
exports.DefaultAvatar = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _concatMiddleware = _interopRequireDefault(require("../concatMiddleware"));

var _ImageAvatar = _interopRequireDefault(require("../../Avatar/ImageAvatar"));

var _InitialsAvatar = _interopRequireDefault(require("../../Avatar/InitialsAvatar"));

var _useStyleSet3 = _interopRequireDefault(require("../../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'relative',
  '> *': {
    left: 0,
    position: 'absolute',
    top: 0
  }
});

var DefaultAvatar = function DefaultAvatar(_ref) {
  var ariaHidden = _ref['aria-hidden'],
      className = _ref.className,
      fromUser = _ref.fromUser;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      avatarStyleSet = _useStyleSet2[0].avatar;

  return _react.default.createElement("div", {
    "aria-hidden": ariaHidden,
    className: (0, _classnames.default)(ROOT_CSS + '', 'webchat__defaultAvatar', fromUser && 'webchat__defaultAvatar--fromUser', avatarStyleSet + '', className)
  }, _react.default.createElement(_InitialsAvatar.default, {
    fromUser: fromUser
  }), _react.default.createElement(_ImageAvatar.default, {
    fromUser: fromUser
  }));
};

exports.DefaultAvatar = DefaultAvatar;
DefaultAvatar.defaultProps = {
  'aria-hidden': true,
  className: ''
};
DefaultAvatar.propTypes = {
  'aria-hidden': _propTypes.default.bool,
  className: _propTypes.default.string,
  fromUser: _propTypes.default.bool.isRequired
};

function createCoreAvatarMiddleware() {
  return (0, _concatMiddleware.default)(function () {
    return function () {
      return function (_ref2) {
        var fromUser = _ref2.fromUser,
            styleOptions = _ref2.styleOptions;
        var botAvatarImage = styleOptions.botAvatarImage,
            botAvatarInitials = styleOptions.botAvatarInitials,
            userAvatarImage = styleOptions.userAvatarImage,
            userAvatarInitials = styleOptions.userAvatarInitials;

        if (fromUser ? userAvatarImage || userAvatarInitials : botAvatarImage || botAvatarInitials) {
          // eslint-disable-next-line react/display-name
          return function () {
            return _react.default.createElement(DefaultAvatar, {
              fromUser: fromUser
            });
          };
        }

        return false;
      };
    };
  });
}